function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var getLeftTaskListItemStyle = function getLeftTaskListItemStyle(prefixCls, token) {
  return _defineProperty({}, ".".concat(prefixCls), _defineProperty(_defineProperty({}, ".list-item", _defineProperty({
    padding: '16px',
    display: 'flex',
    gap: '10px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f0f0f0'
    },
    borderRight: '4px solid #FFFFFF00'
  }, ".list-item-content", _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    display: 'flex',
    flexDirection: 'column'
  }, "h2", {
    margin: '0px',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '22.4px'
  }), "p", {
    margin: '0px'
  }), ".address", {
    color: '#0D1121',
    fontSize: '14px',
    lineHeight: '20px'
  }), ".sub-label", {
    color: '#6E707A',
    fontSize: '12px',
    lineHeight: '16.8px'
  }), ".timeout-tag", {
    color: '#F77234',
    fontSize: '12px',
    lineHeight: '16.8px'
  }))), ".selected-item", {
    background: 'linear-gradient(270deg, #EFF1FF 0%, #F1FEFF 100%)',
    borderRight: '4px solid #4C65ED'
  }));
};